var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMAppLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 16,
    fill: "url(#paint0_linear_1829_10286)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4208 20.09C18.7983 20.6673 14.925 22.8292 15.4886 23.4008C15.5877 23.5013 16.379 23.3814 17.2466 23.1344C19.0919 22.6096 21.0467 22.5552 22.0133 23.0017C23.4294 23.6557 23.6422 24.3841 23.7418 28.9137C23.8466 33.6825 23.9106 33.5782 21.606 32.3945C19.1672 31.1418 17.1329 28.8113 16.6555 26.7236L16.4835 25.9708H13.6531C10.4662 25.9708 10.5805 25.8654 11.258 28.1795C11.83 30.1344 12.8373 32.1418 13.9323 33.5108C15.0968 34.9659 25.3643 45.4074 25.6308 45.4074C25.7445 45.4074 28.4542 42.7282 31.6524 39.4533C38.3018 32.6444 39.3752 31.0665 40.1298 26.9892L40.3183 25.9708H37.4525C35.0577 25.9708 34.587 26.0398 34.587 26.3905C34.587 27.9676 31.8906 31.1741 29.472 32.4725C27.3041 33.6365 27.2957 33.6242 27.2957 29.2288C27.2957 25.011 27.566 23.9286 28.8282 23.0901C29.5995 22.5779 31.9295 22.6469 34.1142 23.2469C35.7037 23.6836 36.0582 23.3923 34.9921 22.5256C32.0105 20.102 26.1455 19.0495 21.4208 20.09Z",
    fill: "url(#paint1_linear_1829_10286)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4612 7.66408C23.5342 7.7818 23.2552 8.11222 23.2493 9.09993C23.2403 10.6362 21.7394 10.9502 20.7999 9.61267C20.3122 8.91843 20.0832 8.80099 19.4988 8.94608C18.2741 9.25022 18.0068 9.7063 18.3808 10.8547C18.6638 11.7239 18.6441 11.9292 18.2339 12.3885C17.6536 13.0387 17.3214 13.0488 16.0903 12.4537C15.1373 11.993 15.1216 11.9954 14.4141 12.7127L13.6998 13.4368L14.4432 14.5241C15.0589 15.4248 15.1348 15.7092 14.8856 16.1814C14.6447 16.6375 14.3252 16.7514 13.2872 16.7514C12.1589 16.7514 11.9491 16.8423 11.6766 17.4486C11.207 18.4936 11.2918 18.9203 12.0382 19.265C12.9509 19.6866 12.8894 20.2275 11.9032 20.4471C10.5435 20.7499 10.9985 21.1315 12.719 21.1315C14.8259 21.1315 16.2453 20.2418 17.2066 18.3192C18.1667 16.3982 19.7419 14.7831 21.5466 13.8687C22.916 13.175 23.4121 13.0754 25.5406 13.0661C27.4831 13.0579 28.2268 13.1756 29.2449 13.6522C31.0088 14.4784 33.1015 16.545 33.8943 18.2436C34.85 20.2919 36.14 21.1315 38.331 21.1315C40.2199 21.1315 40.2637 20.9398 38.6153 19.8851C37.3374 19.0674 37.2945 18.6425 38.4006 17.7651C39.2089 17.1237 39.2299 17.0561 38.9197 16.1026C38.5743 15.0421 38.1557 14.892 36.8954 15.3777C36.3315 15.595 36.0952 15.5425 35.6626 15.1039C35.0158 14.4483 34.9929 13.9766 35.5535 12.8772C35.9588 12.083 35.9497 12.0091 35.3715 11.3852C34.6326 10.5878 34.4574 10.5771 33.5808 11.2763C32.1287 12.4343 30.8841 11.6376 31.2295 9.77118C31.3869 8.91952 31.3305 8.79277 30.6832 8.54311C29.5492 8.1062 29.2705 8.19927 28.6462 9.22312C28.2668 9.84564 27.8568 10.1799 27.4763 10.1772C26.626 10.1709 26.334 9.89464 25.9651 8.74788C25.5838 7.5617 25.536 7.5272 24.4612 7.66408Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1829_10286",
    x1: 25,
    y1: 0,
    x2: 25,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#425D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#334755"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1829_10286",
    x1: 7.84926,
    y1: 26.1085,
    x2: 35.0326,
    y2: 45.3633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB4C9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMAppLogo);
export default __webpack_public_path__ + "static/media/m-app-logo.92adf46fa4518e20641e0f9b44f07df4.svg";
export { ForwardRef as ReactComponent };